import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/ds";
import { ImageUpload } from "@/components/ds/ImageUpload";
import { ResponsiveModal } from "@/components/ds/ResponsiveModal";

const OPTIONS = [
  ["APROVADO", "Aprovado", "border-emerald-500/50 bg-emerald-500/15 text-emerald-300"],
  ["AJUSTES", "Precisa de ajustes", "border-amber-500/50 bg-amber-500/15 text-amber-300"],
  ["FALHOU", "Falhou", "border-destructive/50 bg-destructive/15 text-red-300"],
];

/** Avaliação do resultado da impressão de desenvolvimento. */
export function DevEvaluateModal({ projectId, test, onClose, onSaved }) {
  const [result, setResult] = useState(test.result || "");
  const [notes, setNotes] = useState(test.result_notes || "");
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!result) {
      toast.error("Escolha o resultado da tentativa.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post(`/dev-projects/${projectId}/tests/${test.id}/evaluate`, {
        result,
        notes,
        photos: photo ? [photo] : [],
      });
      onSaved(data);
      toast.success("Resultado registrado no teste.");
      onClose();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <ResponsiveModal
      open
      onOpenChange={(o) => !o && onClose()}
      title={`Resultado do teste #${test.attempt}`}
      description="A impressão foi feita — registre como a peça ficou."
      testid="dev-evaluate-modal"
    >
      <form onSubmit={submit} className="mt-2 flex flex-col gap-4">
        <div className="grid gap-2">
          {OPTIONS.map(([value, label, cls]) => (
            <button
              key={value}
              type="button"
              onClick={() => setResult(value)}
              data-testid={`evaluate-option-${value}`}
              className={`rounded-lg border px-3 py-3 text-left text-sm transition-colors ${
                result === value ? cls : "border-white/10 bg-secondary/40 text-foreground"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
        <Field label="Observações do resultado">
          <Textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            placeholder="Ex.: encaixe ficou perfeito, mas a tampa deformou um pouco"
            data-testid="evaluate-notes-input"
          />
        </Field>
        <Field label="Foto da peça produzida">
          <ImageUpload value={photo} onChange={setPhoto} testid="evaluate-photo" />
        </Field>
        <Button
          type="submit"
          disabled={busy}
          data-testid="save-evaluate-btn"
          className="h-12 rounded-full font-semibold transition-transform active:scale-95"
        >
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar resultado
        </Button>
      </form>
    </ResponsiveModal>
  );
}
